var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7148 7.66553H16.7641V5.76061C16.7641 3.13243 14.6316 1 12.0035 1C9.37528 1 7.23606 3.13243 7.23606 5.76061V7.66553H6.28529C5.23606 7.66553 4.38037 8.52122 4.38037 9.57046V19.0951C4.38037 20.1443 5.23606 21 6.28529 21H17.7148C18.7641 21 19.6198 20.1443 19.6198 19.0951V9.57046C19.6198 8.52122 18.7641 7.66553 17.7148 7.66553ZM9.14098 5.76061C9.14098 4.17827 10.4177 2.90492 11.9967 2.90492C13.5756 2.90492 14.8524 4.18166 14.8524 5.76061V7.66553H9.14098V5.76061ZM17.7114 19.0951H6.28529V9.57046H17.7148V19.0951H17.7114ZM11.9967 16.0323C12.9305 16.0323 13.6945 15.2683 13.6945 14.3345C13.6945 13.4007 12.9305 12.6367 11.9967 12.6367C11.0629 12.6367 10.2989 13.4007 10.2989 14.3345C10.2989 15.2683 11.0629 16.0323 11.9967 16.0323Z",
    fill: "#FEED00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.3719a666812c81ecd650d89558ae6803.svg";
export { ForwardRef as ReactComponent };